

/***********************************
  SocialShare Module
************************************/

Quad.SocialShare = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  var PAGE_URL = document.URL;
  var _shareCopy;


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    _shareCopy = window.shareCopy;
    if (_shareCopy != undefined){
        _setShareUrls();
        _setNewWindows();
    }

  }


  function _setShareUrls() {
    _setFacebookUrl();
    _setTwitterUrl();
    _setLinkedInUrl();  
    _setEmailUrl();
    _setGplusUrl();
  }


  function _setNewWindows(){
    $('#share-nav .nav-link').click(function( event ){
      event.preventDefault();
      _windowOpen( $(this).attr('href') );
    });
  }


  function _windowOpen( href ){
    window.open( href, 'newwindow', 'width=500,height=500' );
  }


  function _setFacebookUrl() {
    var _facebookShareUrl = 'http://www.facebook.com/sharer/sharer.php?u=' + PAGE_URL;
    var $link = $( '.facebook-share' );
    $link.attr( 'href', _facebookShareUrl );
  }


  function _setTwitterUrl() {
    var _twitterShareUrl = 'http://twitter.com/intent/tweet?' + '&status=' + encodeURIComponent( htmlDecode( _shareCopy.tweetCopy )) + ' ' + PAGE_URL;
    var $link = $( '.twitter-share' );
    $link.attr( 'href', _twitterShareUrl );
  }


  function _setLinkedInUrl() {
    var _linkedInShareUrl = 'https://www.linkedin.com/shareArticle?mini=true&url=' + PAGE_URL + '&title=' + encodeURIComponent( _shareCopy.linkedInTitle ) + '&summary='+ encodeURIComponent( customEscape(_shareCopy.linkedInSummary) );
    var $link = $( '.linkedin-share' );
    $link.attr( 'href', _linkedInShareUrl );
  }


  function _setEmailUrl() {
    var _emailUrl = 'mailto:?&subject=' + encodeURIComponent( _shareCopy.emailSubject ) + '&body=' + encodeURIComponent( _shareCopy.emailBody ) + '%0D%0A%0D%0A' + PAGE_URL;
    var $link = $( '.email-share' );
    $link.attr( 'href', _emailUrl );
  }


  function _setGplusUrl() {
    var _gplusShareUrl = 'https://plus.google.com/share?url=' + PAGE_URL;
    var $link = $( '.gplus-share' );
    $link.attr( 'href', _gplusShareUrl );
  }

  function customEscape( str ) {
    var re = /&quot;/g;
    return str.replace( re, '%22' );
  }


  function htmlDecode( input ) {
    var e = document.createElement( 'div' );
    e.innerHTML = input;
    return e.childNodes[ 0 ].nodeValue;
  }


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };


})();
